import { render, staticRenderFns } from "./MyPromotion.vue?vue&type=template&id=600fdb19&scoped=true&"
import script from "./MyPromotion.vue?vue&type=script&lang=js&"
export * from "./MyPromotion.vue?vue&type=script&lang=js&"
import style0 from "./MyPromotion.vue?vue&type=style&index=0&id=600fdb19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600fdb19",
  null
  
)

export default component.exports